import { useState } from 'react';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import ModalTitle from './ModalTitle';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';

import useGlobalStatus from '../../hook/useGlobalStatus';
import { ModalPapper } from '../customStyles/box';
import theme from '../../theme';


const ModalComponent = (props) => {
  const {
    hierarchy,
    isLoading,
    inputErrorMsg,
    setInputErrorMsg,
    handleModalSubmit,
  } = props;

  const { isModalOpen, setIsModalOpen, secondModalOpen, setSecondModalOpen, editMode, modalContent, modalData, setModalData } = useGlobalStatus();

  const handleClose = () => {
    setIsModalOpen(false);
    setSecondModalOpen(false);
  }

  const handleCloseSecondModal = () => {
    setSecondModalOpen(false);
  };

  return (
    <>
      <Modal
        open={hierarchy === 'second' ? secondModalOpen : isModalOpen}
      >
        <ModalPapper>
          {
            modalContent.title &&
            <ModalTitle
              editMode={editMode}
              isLoading={isLoading}
              modalContent={modalContent}
              modalData={modalData}
              handleClose={hierarchy === 'second' ? handleCloseSecondModal : handleClose}
            />
          }

          <Box
            sx={{
              overflow: 'auto',
              padding: modalContent.title ? '32px 24px 16px 24px' : '48px 24px 32px 24px',
            }}
          >
            <ModalBody
              editMode={editMode}
              isLoading={isLoading}
              inputErrorMsg={inputErrorMsg}
              setInputErrorMsg={setInputErrorMsg}
              modalContent={modalContent}
              modalData={modalData}
              setModalData={setModalData}
              handleModalSubmit={handleModalSubmit}
              handleClose={hierarchy === 'second' ? handleCloseSecondModal : handleClose}
            />
          </Box>

          {
            modalContent.type === 'simple' &&
            <ModalFooter
              isLoading={isLoading}
              inputErrorMsg={inputErrorMsg}
              modalContent={modalContent}
              modalData={modalData}
              setModalData={setModalData}
              handleModalSubmit={handleModalSubmit}
              handleClose={hierarchy === 'second' ? handleCloseSecondModal : handleClose}
            />
          }
        </ModalPapper>
      </Modal >
    </>
  );
};

export default ModalComponent;